import {
  CircleArrowLeft,
} from "lucide-react";
import './KypDetailsUiCard.css'
import React, { useRef } from "react";
import { getDocumentPreviewUrl } from '../../utils/fileHelpers';
import FilePreview from '../Common/FilePreview';
import upload from "./../../assets/Images/Request_Property/upload.png";
import close from "./../../assets/Images/Request_Property/close.png";

const KypDetailsUiCard = ({
  backbtnclk,
  tabs,
  activeTab2,
  selectedItem,
  activeTabnew,
  setActiveTabNew,
  ProgressbarForKypForm,
  onViewSocCertificate,
  onViewKypVoucher,
  isSocGenerating,
  hasSocCertificate,
  onUploadLandUseCertificate,
  onRemoveLandUseCertificate,
  isLandUseUploading,
  landUseUploadError,
}) => {
  const landUseInputRef = useRef(null);

  const resolveLandUseCertificateUrl = (item) => {
    if (!item) return '';
    const fromDirectField =
      item?.landUseCertificate ||
      item?.landuseCertificate ||
      item?.land_use_certificate ||
      '';
    return fromDirectField ? getDocumentPreviewUrl(fromDirectField) : '';
  };

  const landUseCertificateUrl = resolveLandUseCertificateUrl(selectedItem);
  const disableLandUseUpload = isLandUseUploading;

  const renderLandUseCertificateUploader = () => (
    <div className="kyp-landuse-uploader-wrap">
      <p className="kyp-landuse-title">Land Use Certificate</p>
      <div
        className="kyp-landuse-uploader-tile"
        onClick={() => !disableLandUseUpload && landUseInputRef.current?.click()}
      >
        <input
          ref={landUseInputRef}
          type="file"
          accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
          style={{ display: 'none' }}
          disabled={disableLandUseUpload}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onUploadLandUseCertificate?.(selectedItem, file);
            e.target.value = '';
          }}
        />
        {!!landUseCertificateUrl && !disableLandUseUpload && (
          <div
            className="kyp-landuse-remove"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveLandUseCertificate?.(selectedItem);
            }}
          >
            <img src={close} width={14} alt="remove" />
          </div>
        )}

        {isLandUseUploading ? (
          <div className="kyp-landuse-loader" />
        ) : landUseCertificateUrl ? (
          <FilePreview
            url={landUseCertificateUrl}
            width="100%"
            height="140px"
            title="LandUse Certificate"
            className="document-preview"
            style={{ border: "none" }}
          />
        ) : (
          <div className="kyp-landuse-placeholder">
            <img src={upload} width={40} alt="Upload" />
            <p>Select Document</p>
          </div>
        )}
      </div>
      {landUseUploadError && (
        <p style={{ color: 'red', margin: '6px 0 0 0', fontSize: '12px' }}>{landUseUploadError}</p>
      )}
    </div>
  );

  const formatFieldLabel = (key = '') => {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .replace(/\b([a-z])/g, (match) => match.toUpperCase())
      .replace(/\bOf\b/gi, 'of')
      .replace(/\bThe\b/gi, 'the')
      .replace(/\bAt\b/gi, 'at')
      .replace(/\bAnd\b/gi, '&')
      .replace(/^./, (s) => s.toUpperCase())
      .trim();
  };

  const resolveServiceText = (...values) => {
    for (const value of values) {
      if (typeof value === "string") {
        const cleaned = value.trim();
        if (!cleaned) continue;
        const lowered = cleaned.toLowerCase();
        if (["false", "true", "null", "undefined", "n/a", "na"].includes(lowered)) {
          continue;
        }
        return cleaned;
      }
      if (typeof value === "boolean") {
        if (!value) continue;
      }
    }
    return "Not selected";
  };

  const marketPlanText =
    selectedItem?.marketPlanLandUseChoice === "applied"
      ? "I have applied with department"
      : selectedItem?.marketPlanLandUseChoice === "upload60Days"
        ? "I will upload in 60 days for my property"
        : resolveServiceText(
          selectedItem?.marketPlanLandUseChoiceText,
          selectedItem?.marketPlanLandUseChoice
        );

  const bankLoanText =
    selectedItem?.bankLoanChoice === "interested"
      ? "I am interested in bank loan in near future"
      : selectedItem?.bankLoanChoice === "sanctioned"
        ? "I already have a sanction loan on the property"
        : resolveServiceText(
          selectedItem?.bankLoanChoiceText,
          selectedItem?.bankLoanChoice
        );

  const titlePossessionText = resolveServiceText(
    selectedItem?.titlePossessionConsentText,
    selectedItem?.titlePossessionConsent === true
      ? "In the future I give my consent to doCity to share my property details with banks and insurance companies and other government departments for the safety of the property"
      : "",
    selectedItem?.titlePossessionConsent
  );

  const getNeighborList = (item) => {
    if (!item || !item.neighbourDetails) return [];
    const details = item.neighbourDetails;
    if (Array.isArray(details)) return details;
    if (typeof details === 'object') {
      return Object.keys(details).map(key => {
        const val = details[key];
        if (typeof val === 'string') return { name: val, direction: key };
        return { direction: key, ...val };
      });
    }
    return [];
  };

  const getNeighborDocs = (neighbor) => {
    if (!neighbor) return [];
    let docs = neighbor.document || neighbor.documents || neighbor.docs || neighbor.files || neighbor.file || neighbor.url || neighbor.doc || [];
    if (typeof docs === 'string') {
      return [{ url: docs }];
    }
    if (typeof docs === 'object' && !Array.isArray(docs)) {
      return [docs];
    }
    if (Array.isArray(docs)) {
      return docs.map(d => {
        if (typeof d === 'string') return { url: d };
        return d;
      }).filter(d => d && (d.url || d.file || d.previewUrl));
    }
    return [];
  };

  const extractSubmittedDocuments = (item) => {
    if (!item) return [];
    const list = [];
    const seenUrls = new Set();

    const getUrl = (val) => {
      if (!val) return '';
      if (typeof val === 'string') return val;
      if (Array.isArray(val) && val.length > 0) {
        return typeof val[0] === 'string' ? val[0] : val[0]?.url || val[0]?.file || val[0]?.previewUrl || '';
      }
      if (typeof val === 'object') return val.url || val.file || val.previewUrl || '';
      return '';
    };

    const addDoc = (title, val, category, note = '') => {
      const url = getUrl(val);
      if (url && !seenUrls.has(url)) {
        seenUrls.add(url);
        list.push({ title, url, category, note });
      }
    };

    addDoc('Future Ownership Document', item.futureOwnershipDoc || item.futureOwnershipDocument || item.future_ownership_doc, 'Legal', item.futureOwnershipDoc?.note || item.futureOwnershipNote);
    addDoc('Owner Photo', item.ownerPhoto || item.owner_photo || item.ownerImage, 'Identification');
    addDoc('Building Main Elevation', item.mainElevation || item.main_elevation || item.elevationPhoto, 'Building');
    addDoc('Architect Document', item.architectDoc || item.architectDocument || item.architect_doc, 'Technical');
    addDoc('Surveyor Document', item.surveyorDoc || item.surveyorDocument || item.surveyor_doc, 'Technical');
    addDoc('Boundary Layout / Drawing', item.drawings?.url || item.drawings, 'Technical', item.drawings?.note || '');
    addDoc('Land Use Certificate', item.landUseDoc || item.landUseCertificate || item.land_use_certificate || item.landuseCertificate, 'Certificate');

    Object.keys(item).forEach(key => {
      if (['futureOwnershipDoc', 'ownerPhoto', 'mainElevation', 'architectDoc', 'surveyorDoc', 'landUseDoc', 'Department_wise_Documents', 'neighbourDetails'].includes(key)) return;
      const val = item[key];
      const url = getUrl(val);
      if (url && (url.startsWith('http') || url.includes('/uploads') || /\.(pdf|png|jpg|jpeg|doc|docx|svg)$/i.test(url))) {
        const formattedTitle = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        addDoc(formattedTitle, val, 'Attachment');
      }
    });

    return list;
  };

  return (
    <div className="kyp-dashboard-container">
      <div className="kyp-dashboard-header">
        <div className="kyp-dashboard-header-title">
          <CircleArrowLeft width={36} height={36} className="back-arrow" onClick={backbtnclk} />
          <div>
            <h1>KYP Details Summary</h1>
            <p className="subtitle">Property validation overview and collected files</p>
          </div>
        </div>
        <div className="kyp-dashboard-header-actions">
          <button
            type="button"
            className="btn-certificate-action"
            onClick={() => onViewSocCertificate?.(selectedItem)}
            disabled={isSocGenerating}
          >
            {isSocGenerating ? 'Generating OC...' : hasSocCertificate ? 'View Certificate' : 'Generate & View Certificate'}
          </button>
          <button
            type="button"
            className="btn-certificate-action btn-voucher"
            onClick={() => onViewKypVoucher?.(selectedItem)}
            disabled={isSocGenerating}
          >
            Voucher
          </button>
        </div>
      </div>

      <div className="kyp-dashboard-grid">
        <div className="kyp-dashboard-sidebar">
          <div className="sidebar-card progress-card">
            <h2>Verification Status</h2>
            <ProgressbarForKypForm UserUploadedDocs={selectedItem} />
          </div>
          <div className="sidebar-card owner-card">
            <h2>Owner Info</h2>
            <div className="sidebar-info-list">
              <div className="info-item">
                <span className="info-label">Name</span>
                <span className="info-value">{selectedItem.ownerName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Email</span>
                <span className="info-value">{selectedItem.email}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Mobile</span>
                <span className="info-value">{selectedItem.mobile}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Aadhaar</span>
                <span className="info-value">{selectedItem.aadhar || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Firm Type</span>
                <span className="info-value">{selectedItem.firmType || 'Individual'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Representative</span>
                <span className="info-value">
                  {selectedItem.filledBy === "owner" ? "Self" : "Other Person"}
                </span>
              </div>
            </div>

            {(() => {
              const other = Array.isArray(selectedItem.otherPersonDetails)
                ? selectedItem.otherPersonDetails[0]
                : selectedItem.otherPersonDetails;

              if (selectedItem.filledBy !== "owner" && other && Object.values(other).some(val => val)) {
                return (
                  <div className="representative-details mt-4">
                    <h3>Representative Details</h3>
                    <div className="sidebar-info-list">
                      <div className="info-item">
                        <span className="info-label">Name</span>
                        <span className="info-value">{other.name || 'N/A'}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">DOB / Age</span>
                        <span className="info-value">
                          {other.dob || 'N/A'} ({other.age ? `${other.age} yrs` : 'N/A'})
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Email</span>
                        <span className="info-value">{other.email || 'N/A'}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Address</span>
                        <span className="info-value">{other.address || 'N/A'}</span>
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            })()}
          </div>
          <div className="sidebar-card checks-card">
            <h2>Status Check</h2>
            <div className="status-pill-list">
              <div className="status-pill-row">
                <span>Legal Status</span>
                <span className="status-tag tag-success">{selectedItem.legalStatus || 'N/A'}</span>
              </div>
              <div className="status-pill-row">
                <span>Financial Status</span>
                <span className="status-tag tag-info">{selectedItem.financialStatus || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="kyp-dashboard-content">
          <div className="detail-card">
            <h2>Property & Location Details</h2>
            <div className="detail-grid">
              <div className="grid-item">
                <span className="item-label">Location Address</span>
                <span className="item-value">{selectedItem.location || 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">Post Office</span>
                <span className="item-value">{selectedItem.pd || 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">Postal Code</span>
                <span className="item-value">{selectedItem.postalCode || 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">SRO (Sub Registrar Office)</span>
                <span className="item-value">{selectedItem.sro || 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">Market Value</span>
                <span className="item-value">{selectedItem.marketValue || 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">AMSL Elevation</span>
                <span className="item-value">{selectedItem.amsl ? `${selectedItem.amsl} ft` : 'N/A'}</span>
              </div>
              {selectedItem.googleLocation && (
                <div className="grid-item">
                  <span className="item-label">Google Location</span>
                  <span className="item-value">
                    <a href={selectedItem.googleLocation} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-turquoise-teal)', fontWeight: '600' }}>
                      View on Google Maps
                    </a>
                  </span>
                </div>
              )}
              {selectedItem.ownedSince && (
                <div className="grid-item">
                  <span className="item-label">Owned Since</span>
                  <span className="item-value">{selectedItem.ownedSince}</span>
                </div>
              )}
            </div>
          </div>
          <div className="detail-card">
            <h2>Submitted Form Documents & Attachments</h2>
            {extractSubmittedDocuments(selectedItem).length > 0 ? (
              <div className="submitted-docs-grid">
                {extractSubmittedDocuments(selectedItem).map((doc, idx) => (
                  <div key={idx} className="submitted-doc-card">
                    <div className="submitted-doc-header">
                      <span className="doc-category-tag">{doc.category}</span>
                      <h3 className="doc-title">{doc.title}</h3>
                    </div>
                    {doc.url ? (
                      <div className="submitted-doc-preview-box">
                        <FilePreview
                          url={doc.url}
                          title={doc.title}
                          height="100px"
                          showOpenInNewTab={true}
                        />
                      </div>
                    ) : (
                      <div className="no-file-badge">No document preview</div>
                    )}
                    {doc.note && (
                      <p className="doc-note-text"><strong>Note:</strong> {doc.note}</p>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-docs-text">No additional form attachments uploaded.</p>
            )}
          </div>

          <div className="detail-card">
            <h2>Specifications & Construction</h2>
            <div className="detail-grid">
              <div className="grid-item">
                <span className="item-label">Building Age</span>
                <span className="item-value">{selectedItem.buildingAge ? `${selectedItem.buildingAge} years` : 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">Annual Tax Details</span>
                <span className="item-value">{selectedItem.taxDetails || 'N/A'}</span>
              </div>
              <div className="grid-item">
                <span className="item-label">Property Type</span>
                <span className="item-value">{selectedItem.selectedPropertyType || 'N/A'}</span>
              </div>
            </div>

            {selectedItem.constructionDetails && (
              <div className="detail-block-text mt-3">
                <span className="item-label">Construction Details</span>
                <p>{selectedItem.constructionDetails}</p>
              </div>
            )}
            {selectedItem.buildingDescription && (
              <div className="detail-block-text mt-3">
                <span className="item-label">Building Description</span>
                <p>{selectedItem.buildingDescription}</p>
              </div>
            )}
            {selectedItem.roadDetails && (
              <div className="detail-block-text mt-3">
                <span className="item-label">Road Information</span>
                <p>{selectedItem.roadDetails}</p>
              </div>
            )}
            {selectedItem.architectDetails && (
              <div className="detail-block-text mt-3">
                <span className="item-label">Architect Details</span>
                <p>{selectedItem.architectDetails}</p>
              </div>
            )}
            {selectedItem.civilEngineerDetails && (
              <div className="detail-block-text mt-3">
                <span className="item-label">Civil Engineer Details</span>
                <p>{selectedItem.civilEngineerDetails}</p>
              </div>
            )}
          </div>
          <div className="detail-card">
            <h2>Boundary & Neighbour Information</h2>
            {selectedItem?.drawings?.url && (
              <div className="mb-4">
                <span className="item-label" style={{ fontSize: '11px', color: '#4f46e5', fontWeight: '700' }}>
                  📐 BOUNDARY LAYOUT / SITE DRAWING
                </span>
                <div className="submitted-doc-preview-box mt-2" style={{ height: '160px' }}>
                  <FilePreview
                    url={selectedItem.drawings.url}
                    title="Boundary Drawing / Site Plan"
                    height="160px"
                    showOpenInNewTab={true}
                  />
                </div>
                {selectedItem.drawings.note && (
                  <div className="neighbour-doc-note-badge mt-2">
                    <strong>📄 Drawing Note:</strong> {selectedItem.drawings.note}
                  </div>
                )}
              </div>
            )}

            <div className="neighbour-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '12px', width: '100%' }}>
              {getNeighborList(selectedItem).length > 0 ? (
                getNeighborList(selectedItem).map((neighbor, index) => {
                  const docs = getNeighborDocs(neighbor);
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        background: '#ffffff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '10px',
                        padding: '12px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                        position: 'relative',
                        boxSizing: 'border-box',
                        minHeight: '140px',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', marginBottom: '8px' }}>
                        <div>
                          <div style={{ fontSize: '10px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '2px' }}>
                            Neighbour Name
                          </div>
                          <h3 style={{ fontSize: '13.5px', fontWeight: '700', color: '#0f172a', margin: 0 }}>
                            {neighbor?.name || neighbor?.neighbourName || "N/A"}
                          </h3>
                        </div>
                        <span style={{ fontSize: '10px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', background: '#f1f5f9', padding: '3px 8px', borderRadius: '5px', letterSpacing: '0.03em' }}>
                          {neighbor?.direction || neighbor?.side || 'Side'} Side
                        </span>
                      </div>

                      {docs.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', flex: 1, marginTop: '4px' }}>
                          <div style={{ fontSize: '10px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                            Uploaded Document ({docs.length})
                          </div>
                          {docs.map((doc, docIdx) => {
                            const fileUrl = doc?.url || doc?.file || doc?.previewUrl || (typeof doc === 'string' ? doc : '');
                            const docNote = doc?.note || neighbor?.note || '';
                            return (
                              <div key={docIdx} style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '100%' }}>
                                {fileUrl ? (
                                  <>
                                    <div style={{ width: '100%', height: '90px', borderRadius: '6px', border: '1px solid #cbd5e1', overflow: 'hidden', position: 'relative', background: '#f8fafc' }}>
                                      <FilePreview
                                        url={fileUrl}
                                        previewUrl={doc?.previewUrl}
                                        title={`Document ${docIdx + 1}`}
                                        height="90px"
                                        showOpenInNewTab={true}
                                      />
                                    </div>
                                    {docNote && (
                                      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '5px 8px', fontSize: '11px', color: '#334155' }}>
                                        <strong>📄 Note:</strong> {docNote}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '6px', padding: '8px', textAlign: 'center', fontSize: '11px', color: '#64748b' }}>
                                    Document uploaded (Link pending)
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '6px', padding: '10px', textAlign: 'center', fontSize: '11px', color: '#94a3b8', marginTop: '6px' }}>
                          No documents uploaded for this boundary
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="no-docs-text">No neighbor boundary details provided</p>
              )}
            </div>
          </div>
          <div className="detail-card">
            <h2>Services & Consents</h2>
            <div className="services-selected-list-right">
              <div className="services-row-right">
                <span className="services-label-right">Ownership Certificate Declaration</span>
                <span className="services-value-right">{selectedItem?.ownershipCertificateDeclaration || 'Not selected'}</span>
              </div>
              <div className="services-row-right">
                <span className="services-label-right">Market plan, land use certificate</span>
                <span className="services-value-right">{marketPlanText}</span>
              </div>
              <div className="services-row-right">
                <span className="services-label-right">Bank Loan Support</span>
                <span className="services-value-right">{bankLoanText}</span>
              </div>
              <div className="services-row-right">
                <span className="services-label-right">Title Possession Consent</span>
                <span className="services-value-right">{titlePossessionText}</span>
              </div>
            </div>

            <hr className="divider-line" />

            <div className="consents-checklist">
              <div className="checklist-group">
                <h3>Consent Status</h3>
                <div className="checklist-row">
                  <span>Consent for Sharing</span>
                  <span className={`check-status ${selectedItem.consentSharing ? 'yes' : 'no'}`}>
                    {selectedItem.consentSharing ? "Granted" : "Declined"}
                  </span>
                </div>
                <div className="checklist-row">
                  <span>Consent for Survey</span>
                  <span className={`check-status ${selectedItem.consentSurvey ? 'yes' : 'no'}`}>
                    {selectedItem.consentSurvey ? "Granted" : "Declined"}
                  </span>
                </div>
                <div className="checklist-row">
                  <span>Future Title Guarantee</span>
                  <span className={`check-status ${selectedItem.futureTitleGuarantee ? 'yes' : 'no'}`}>
                    {selectedItem.futureTitleGuarantee ? "Granted" : "Declined"}
                  </span>
                </div>
              </div>

              <div className="checklist-group">
                <h3>Self Declarations</h3>
                <div className="checklist-row">
                  <span>Declaration 1</span>
                  <span className={`check-status ${selectedItem.selfDeclaration ? 'yes' : 'no'}`}>
                    {selectedItem.selfDeclaration ? "Accepted" : "Pending"}
                  </span>
                </div>
                <div className="checklist-row">
                  <span>Declaration 2</span>
                  <span className={`check-status ${selectedItem.selfDeclaration2 ? 'yes' : 'no'}`}>
                    {selectedItem.selfDeclaration2 ? "Accepted" : "Pending"}
                  </span>
                </div>
                <div className="checklist-row">
                  <span>Declaration 3</span>
                  <span className={`check-status ${selectedItem.selfDeclaration3 ? 'yes' : 'no'}`}>
                    {selectedItem.selfDeclaration3 ? "Accepted" : "Pending"}
                  </span>
                </div>
                <div className="checklist-row">
                  <span>International Governance</span>
                  <span className={`check-status ${selectedItem.internationalGovernance ? 'yes' : 'no'}`}>
                    {selectedItem.internationalGovernance ? "Accepted" : "Pending"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {(selectedItem.architectDetails || selectedItem.civilEngineerDetails || (selectedItem.consultants && selectedItem.consultants.length > 0) || (selectedItem.contractors && selectedItem.contractors.length > 0)) && (
            <div className="detail-card">
              <h2>Professional Team Details</h2>
              <div className="team-grid">
                {selectedItem.architectDetails && (
                  <div className="team-item">
                    <span className="team-item-label">Architect Details</span>
                    <p className="team-item-value">{selectedItem.architectDetails}</p>
                  </div>
                )}
                {selectedItem.civilEngineerDetails && (
                  <div className="team-item">
                    <span className="team-item-label">Civil Engineer</span>
                    <p className="team-item-value">{selectedItem.civilEngineerDetails}</p>
                  </div>
                )}
                {selectedItem?.consultants?.length > 0 && (
                  <div className="team-item">
                    <span className="team-item-label">Consultants</span>
                    {selectedItem.consultants.map((x, index) => (
                      <p key={index} className="team-item-value">{x}</p>
                    ))}
                  </div>
                )}
                {selectedItem?.contractors?.length > 0 && (
                  <div className="team-item">
                    <span className="team-item-label">Contractors</span>
                    {selectedItem.contractors.map((x, index) => (
                      <p key={index} className="team-item-value">{x}</p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Card 6: Land Use Certificate Uploader */}
          <div className="detail-card text-center">
            {renderLandUseCertificateUploader()}
          </div>

          {/* Card 7: Department-wise Documents */}
          {selectedItem?.Department_wise_Documents && selectedItem.Department_wise_Documents.length > 0 && (
            <div className="detail-card">
              <h2>Department‑Wise Uploaded Documents</h2>
              <div className="dept-tabs">
                <button
                  className={`dept-tab ${activeTabnew === 'detailed' ? 'active' : ''}`}
                  onClick={() => setActiveTabNew('detailed')}
                >
                  Department view
                </button>
                <button
                  className={`dept-tab ${activeTabnew === 'simple' ? 'active' : ''}`}
                  onClick={() => setActiveTabNew('simple')}
                >
                  Chronological list
                </button>
              </div>

              {activeTabnew === 'detailed' ? (
                <div className="dept-list-stacked">
                  {selectedItem.Department_wise_Documents.flatMap((dept, dIdx) =>
                    Object.entries(dept.files || {}).flatMap(([catKey, docs]) =>
                      docs.map((doc, docIdx) => (
                        <div key={`${dIdx}-${catKey}-${docIdx}`} className="dept-document-row">
                          <div className="dept-document-info">
                            <h3>{dept.descriptions?.[catKey] || 'Department Document'}</h3>
                            <div className="dept-document-meta-grid">
                              {doc.fields && Object.entries(doc.fields).map(([fieldKey, fieldVal]) => {
                                if (!fieldVal || fieldKey === '__v') return null;
                                let displayVal = fieldVal;
                                if (fieldKey === 'datethedocumentwasissued' && typeof fieldVal === 'string' && fieldVal.includes('-')) {
                                  displayVal = fieldVal.split('-').reverse().join('-');
                                }
                                return (
                                  <div key={fieldKey} className="dept-meta-item">
                                    <span className="dept-meta-label">{formatFieldLabel(fieldKey)}</span>
                                    <span className="dept-meta-value">{displayVal}</span>
                                  </div>
                                );
                              })}
                              {(!doc.fields || Object.keys(doc.fields).length === 0) && (
                                <div className="dept-meta-item">
                                  <span className="dept-meta-label">Info</span>
                                  <span className="dept-meta-value">No metadata available</span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="dept-document-preview-pane">
                            {doc.file ? (
                              <div className="file-preview-row">
                                <iframe
                                  src={getDocumentPreviewUrl(doc.file)}
                                  title={`Doc-${dIdx}-${docIdx}`}
                                  className="dept-row-iframe"
                                />
                                <a
                                  href={doc.file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn-view-doc"
                                >
                                  View Full File
                                </a>
                              </div>
                            ) : (
                              <div className="no-file-badge">No document file</div>
                            )}
                          </div>
                        </div>
                      ))
                    )
                  )}
                </div>
              ) : (
                <div className="dept-list-chronological">
                  {selectedItem.Department_wise_Documents.flatMap((dept) =>
                    Object.values(dept.files || {}).flatMap((docs) =>
                      docs.map((doc) => ({
                        date: doc.fields?.datethedocumentwasissued || '',
                        type: doc.fields?.typeofdocument || 'Document',
                        file: doc.file || null,
                      }))
                    )
                  )
                    .sort((a, b) => new Date(a.date) - new Date(b.date))
                    .map((doc, idx) => (
                      <div key={idx} className="chronological-row-item">
                        <div className="chrono-header">
                          <span className="chrono-date">{doc.date?.split('-').reverse().join('-') || 'No Date'}</span>
                          <span className="chrono-type">{doc.type}</span>
                        </div>
                        {doc.file ? (
                          <a
                            href={doc.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-chrono-view"
                          >
                            Open Document
                          </a>
                        ) : (
                          <span className="no-file-text">No file uploaded</span>
                        )}
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KypDetailsUiCard;

